(function () {
  var root = document.querySelector('[data-cce]');
  var dataEl = document.querySelector('[data-cce-data]');
  if (!root || !dataEl) return;
  var D = JSON.parse(dataEl.textContent);
  var GASOIL = 49059516973383, HIDDEN = ['navidium-shipping-protection'];
  var shipFR = D.ship.FR || [7900, 1000], FRANCO = shipFR[0], SHIP_COST = shipFR[1];
  var PROMO = D.promo || [], lastPct = {};
  // Vente flash en cours (cc_rules.vente_flash_menu, même config que le menu) : prix flash, prix barré et cartouche.
  var VFN = window.ccNow ? window.ccNow() : Date.now();
  var VF = D.vf && VFN >= Date.parse(D.vf.debut) && VFN < Date.parse(D.vf.fin) ? D.vf : null;
  // Quantité maximale par commande (cc_rules.max_par_commande, ex. colis mystère = 1).
  var MAXQ = D.maxq || {};
  function maxOf(v) { return v ? +MAXQ[v.p.id] || 0 : 0; }
  function capQ(vid, n) {
    var mx = maxOf(byVid[vid]);
    if (mx && n > mx) { T('express', 'max_par_commande', String(byVid[vid].p.id), { max: mx }); return mx; }
    return n;
  }
  function T() { try { (window.__ccq = window.__ccq || []).push([].slice.call(arguments)); } catch (e) {} }

  /* ---------- client ouvert depuis l'extension CRM (#crm=) ---------- */
  // Même contrat que shopify/commande-express-prefill.html du repo CRM-extension : la page gère le
  // pré-remplissage, l'extension s'efface (data-cfm-prefill) et le checkout est pré-rempli par Shopify.
  var CRM_KEY = '__coiffissimo_autofill', crmFresh = false;
  document.documentElement.setAttribute('data-cfm-prefill', 'page');
  if (location.hash.indexOf('#crm=') === 0) {
    try {
      var crmJson = decodeURIComponent(atob(location.hash.slice(5)));
      JSON.parse(crmJson);
      sessionStorage.setItem(CRM_KEY, crmJson);
      crmFresh = true;
      history.replaceState(null, '', location.pathname + location.search);
    } catch (e) {}
  }
  function crmClient() {
    try { return JSON.parse(sessionStorage.getItem(CRM_KEY) || 'null'); } catch (e) { return null; }
  }
  function crmCheckoutUrl(d) {
    var p = new URLSearchParams();
    if (d.email) p.set('checkout[email]', d.email);
    if (d.first_name) p.set('checkout[shipping_address][first_name]', d.first_name);
    if (d.last_name) p.set('checkout[shipping_address][last_name]', d.last_name);
    if (d.address1) p.set('checkout[shipping_address][address1]', d.address1);
    if (d.zip) p.set('checkout[shipping_address][zip]', d.zip);
    if (d.ville) p.set('checkout[shipping_address][city]', d.ville);
    if (d.phone) p.set('checkout[shipping_address][phone]', d.phone);
    p.set('checkout[shipping_address][country]', String(d.phone || '').indexOf('+32') === 0 ? 'Belgium' : 'France');
    return '/checkout?' + p.toString();
  }
  (function crmBadge() {
    var d = crmClient();
    if (!d || document.getElementById('cfm-autofill-badge')) return;
    var el = document.createElement('div');
    el.id = 'cfm-autofill-badge';
    el.className = 'cce-crm';
    el.textContent = 'Client prêt : ' + ([d.first_name, d.last_name].filter(Boolean).join(' ') || d.email || d.phone || 'client');
    document.body.appendChild(el);
  })();
  // Le panier coulissant enverra le paiement vers ce checkout pré-rempli (voir cc-cart.js).
  (function () { var d = crmClient(); try { if (d) sessionStorage.setItem('cc_crm_checkout', crmCheckoutUrl(d)); } catch (e) {} })();

  /* ---------- utilitaires ---------- */
  function norm(s) { return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9.]+/g, ' ').trim(); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(c) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; }
  function cleanVariant(t) { return String(t || '').replace(/\s*-\s*[\d.,]+\s*€\s*ht\s*$/i, '').replace(/\s*-\s*rupture de stock\s*$/i, '').trim(); }
  function has(list, x) { return (list || []).some(function (y) { return String(y) === String(x); }); }

  /* ---------- catalogue ---------- */
  // Rubrique : la « maison » du produit dans le menu. Les blocs « Pour vos … » et « Le matériel qui va avec »
  // ne sont que des mises en avant. Patines rejoint Coloration, les oxydants ont leur rubrique.
  var ORDER = ['Colorations', 'Décolorations', 'Oxydants', 'Shampooings et soins', 'Coiffants', 'Permanente'];
  function companion(sec) { return /^pour vos |^le materiel qui va avec/.test(norm(sec) + ' '); }
  var home = {}, anyTop = {};
  D.menu.forEach(function (m) {
    var top = m[1] === 'Patines' ? 'Colorations' : m[1];
    if (!anyTop[m[0]]) anyTop[m[0]] = top;
    if (!companion(m[2]) && !home[m[0]]) home[m[0]] = top;
  });
  // Sous-rubrique du matériel : première section non « mise en avant » du menu Matériel.
  var matSub = {}, matSubs = [];
  D.menu.forEach(function (m) {
    if (m[1] !== 'Matériel' || companion(m[2])) return;
    if (!matSub[m[0]]) matSub[m[0]] = m[2];
    if (matSubs.indexOf(m[2]) < 0) matSubs.push(m[2]);
  });
  var ci = matSubs.indexOf('Coupe et coiffage');
  if (ci >= 0) matSubs.splice(ci, 1, 'Ciseaux et rasoirs', 'Brosses et peignes');
  else matSubs.push('Ciseaux et rasoirs', 'Brosses et peignes');
  // L'hygiène ferme toujours la commande express, après le reste du matériel.
  matSubs.push('Autres');
  matSubs = matSubs.filter(function (s) { return !/^hygiene/.test(norm(s)); }).concat(matSubs.filter(function (s) { return /^hygiene/.test(norm(s)); }));
  var units = D.units || {};
  function unitOf(P) {
    var n = norm(P.t);
    if (/shampoo?ing/.test(n) || /oxydant/.test(n) || /fixateur|easyfix/.test(n)) return ['bouteille', 'bouteilles'];
    if (/masque/.test(n)) return ['pot', 'pots'];
    var u = units[P.id];
    return u && u[0] !== 'L' ? u : ['article', 'articles'];
  }
  var products = D.p.map(function (p) {
    var cl = D.claims[p.id] || {};
    var P = {
      id: p.id, url: p.u, t: p.t, name: p.n, desc: p.d, img: p.i, badge: p.b, sales: p.s,
      brand: (p.m || []).join(' '), args: cl.a || [], nh3: cl.nh3 || '', shades: p.sh && p.v.length > 1, one: p.one,
      top: /oxydant/.test(norm(p.t)) ? 'Oxydants' : (home[p.id] || anyTop[p.id] || 'Autres produits'),
      menuRank: D.menu.findIndex(function (m) { return m[0] === p.id; }),
      f: p.f || {}, sub: matSub[p.id] || 'Autres'
    };
    // Coupe et coiffage se sépare en deux : ciseaux et rasoirs d'un côté, brosses et peignes (miroirs, pinces) de l'autre ; le lubrifiant rejoint la tondeuse.
    var nt = norm(p.t);
    if (P.sub === 'Coupe et coiffage') P.sub = /ciseau|rasoir|feather/.test(nt) ? 'Ciseaux et rasoirs' : /lubri/.test(nt) && matSubs.indexOf('Électrique') >= 0 ? 'Électrique' : 'Brosses et peignes';
    P.unit = unitOf(P);
    P.vars = p.v.map(function (v) {
      var m = String(v.t).match(/^\s*(\d{1,2}(?:\.\d{1,2})?)\s*-?\s*(.*)$/);
      return { id: v.id, p: P, price: v.p, cmp: v.c, av: v.a, sku: v.k, img: v.i,
        code: P.shades ? (v.n || (m && m[1]) || '') : '', label: P.shades ? cleanVariant(m ? m[2] : v.t) : cleanVariant(v.t) };
    });
    // Avec / sans pompe : une seule ligne par format avec un interrupteur, « avec pompe » par défaut.
    var pairs = {};
    P.vars.forEach(function (v) {
      var m = v.label.match(/^(.*?)\s*[-\/]?\s*\b(avec|sans) pompe\b\s*(.*)$/i);
      if (!m) return;
      var base = (m[1] + ' ' + m[3]).replace(/^[\s\-\/]+|[\s\-\/]+$/g, '').trim();
      (pairs[base] = pairs[base] || { base: base })[m[2].toLowerCase()] = v;
    });
    var pl = Object.keys(pairs).map(function (k) { return pairs[k]; });
    if (pl.length && pl.every(function (x) { return x.avec && x.sans; }) && pl.length * 2 === P.vars.length) {
      P.pairs = pl;
      pl.forEach(function (x) { x.key = P.id + '|' + x.base; x.avec.pair = x.sans.pair = x; });
    }
    var prices = (P.pairs ? P.pairs.map(function (x) { return x.avec; }) : P.vars).map(function (v) { return v.price; });
    P.min = Math.min.apply(null, prices); P.varies = Math.max.apply(null, prices) !== P.min;
    P.cmp = Math.max.apply(null, P.vars.map(function (v) { return v.cmp; }));
    P.key = norm([P.name, P.t, P.desc].join(' '));
    // Remise flash = montant fixe par unité (prix de vente flash du produit), appliquée à chaque variante.
    P.vfStar = !!(VF && String(VF.vedette) === String(P.id));
    if (VF && String(VF.produit) === String(P.id)) P.vfOff = Math.max(0, P.min - Math.round(parseFloat(String(VF.prix).replace(',', '.')) * 100));
    P.vars.forEach(function (v) { v.key = norm([v.code, v.label, v.sku].join(' ')); });
    return P;
  });
  var byVid = {};
  products.forEach(function (P) { P.vars.forEach(function (v) { byVid[v.id] = v; }); });

  function sortIn(list) { return list.sort(function (a, b) { return (!a.nh3 - !b.nh3) || ((a.menuRank < 0) - (b.menuRank < 0)) || (a.menuRank - b.menuRank) || (b.sales - a.sales); }); }
  var sections = [];
  // Promos et nouveautés : 5 produits au plus, les nouveautés Coiffissimo d'abord.
  var isCoif = function (P) { return /coiffissimo/i.test(P.brand); };
  var hi = products.filter(function (P) { return P.badge || P.vfOff || P.vfStar; }).sort(function (a, b) {
    if (a.vfStar !== b.vfStar) return a.vfStar ? -1 : 1;
    if (!a.vfOff !== !b.vfOff) return a.vfOff ? -1 : 1;
    var ra = a.badge === 'Nouveau' && isCoif(a) ? 0 : a.badge === 'Promo' ? 1 : 2;
    var rb = b.badge === 'Nouveau' && isCoif(b) ? 0 : b.badge === 'Promo' ? 1 : 2;
    return (ra - rb) || (b.sales - a.sales);
  }).slice(0, 5);
  if (hi.length) sections.push({ key: 'promos', title: 'Promos et nouveautés', list: hi, hi: true });
  var tops = ORDER.slice();
  D.tops.forEach(function (t) { if (t !== 'Patines' && t !== 'Matériel' && tops.indexOf(t) < 0) tops.push(t); });
  tops.push('Autres produits', 'Matériel');
  tops.forEach(function (t) {
    var list = sortIn(products.filter(function (P) { return P.top === t; }));
    if (list.length) sections.push({ key: t, title: t, list: list });
  });
  // Matériel : les consommables (petit matériel le plus vendu) d'abord, puis une catégorie par sous-rubrique du menu.
  var CONSO_MAX = 12, CONSO_PRIX = 2000;
  sections.forEach(function (S) {
    if (S.key !== 'Matériel') return;
    var conso = S.list.filter(function (P) { return P.min <= CONSO_PRIX && P.sales > 0; })
      .sort(function (a, b) { return b.sales - a.sales; }).slice(0, CONSO_MAX);
    S.groups = [{ key: 'conso', title: 'Consommables', list: conso }];
    matSubs.forEach(function (sub) {
      var list = S.list.filter(function (P) { return P.sub === sub && conso.indexOf(P) < 0; }).sort(function (a, b) { return b.sales - a.sales; });
      if (list.length) S.groups.push({ key: sub, title: sub === 'Autres' ? 'Autre matériel' : sub, list: list });
    });
  });
  var FACS = (D.fac || []).filter(function (f) { return ['marque', 'main', 'format', 'contenance', 'matiere'].indexOf(f.k) >= 0; });
  if (!FACS.length) FACS = [{ k: 'marque', l: 'Marque' }, { k: 'format', l: 'Taille / format' }, { k: 'matiere', l: 'Matière' }];

  /* ---------- état ---------- */
  var qty = {};        // variant_id → quantité voulue
  var cart = null;
  var state = { q: '', sec: 'all', only: false, open: {}, sumOpen: {}, mf: {}, ms: {}, pump: {} };
  try { state.open = JSON.parse(localStorage.getItem('cce-open') || '{}'); } catch (e) {}
  state.open[11215489270087] = true; // Color Mask : nuances dépliées à chaque ouverture

  function pQty(P) { return P.vars.reduce(function (a, v) { return a + (qty[v.id] || 0); }, 0); }

  /* ---------- rendu ---------- */
  var MINUS = '−';
  function stepper(v) {
    var q = qty[v.id] || 0;
    if (!v.av && !q) return '<span class="cce-out">Bientôt de retour</span>';
    return '<span class="cce-step' + (q ? ' on' : '') + '" data-step="' + v.id + '">' +
      '<button type="button" tabindex="-1" data-d="-1" aria-label="Retirer un"' + (q ? '' : ' disabled') + '>' + MINUS + '</button>' +
      '<input type="text" inputmode="numeric" pattern="[0-9]*" value="' + q + '" aria-label="Quantité ' + esc(v.p.name + ' ' + (v.code || v.label)) + '">' +
      '<button type="button" tabindex="-1" data-d="1" aria-label="Ajouter un"' + (maxOf(v) && q >= maxOf(v) ? ' disabled title="Maximum ' + maxOf(v) + ' par commande"' : '') + '>+</button></span>';
  }
  // Palier de remise atteint par la commande en cours (remises automatiques synchronisées dans cc_config) : % pour ce produit.
  function pctOf(pid) {
    var best = 0;
    PROMO.forEach(function (pg) {
      if (pg.productIds.indexOf(pid) < 0) return;
      var n = 0;
      Object.keys(qty).forEach(function (vid) { var v = byVid[vid]; if (v && pg.productIds.indexOf(v.p.id) >= 0) n += qty[vid]; });
      pg.tiers.forEach(function (t) { if (n >= t[0] && t[1] > best) best = t[1]; });
    });
    return best;
  }
  function disc(price, pct) { return Math.round(price * (100 - pct) / 100); }
  function unitPrice(v) { return v.p.vfOff ? v.price - v.p.vfOff : disc(v.price, pctOf(v.p.id)); }
  function vfTag(P, price) {
    return '<em class="cce-vf" style="background:' + esc(VF.couleur) + ';color:' + esc(VF.texte_couleur || '#FFFFFF') + '">' + esc(VF.pastille || 'Vente flash') + ' -' + Math.round(P.vfOff / price * 100) + ' %</em>';
  }
  // Produit vedette de l'opération en cours : accroche, arguments et chrono sous le nom.
  function vfStarHtml() {
    return '<div class="cce-vfx">' +
      '<ul class="cce-vfx-l">' + (VF.arguments_express || (VF.accroche ? [VF.accroche] : []).concat(VF.arguments || [])).map(function (a) { return '<li>' + esc(a) + '</li>'; }).join('') +
      '<li class="cce-vfx-c">Fin dans <b data-cce-cd>' + countdown() + '</b></li></ul></div>';
  }
  function countdown() {
    var s = Math.max(0, Math.floor((Date.parse(VF.fin) - (window.ccNow ? window.ccNow() : Date.now())) / 1000)), d = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600);
    var z = function (x) { return (x < 10 ? '0' : '') + x; };
    return (d ? d + ' j ' : '') + z(h) + ':' + z(Math.floor(s % 3600 / 60)) + ':' + z(s % 60);
  }
  if (VF && VF.vedette) setInterval(function () { var t = countdown(); root.querySelectorAll('[data-cce-cd]').forEach(function (e) { e.textContent = t; }); }, 1000);
  function priceHtml(P, v) {
    var price = v ? v.price : P.min, cmp = v ? v.cmp : P.cmp, pct = pctOf(P.id);
    var attrs = ' data-prp="' + P.id + '"' + (v ? ' data-prv="' + v.id + '"' : '');
    var from = !v && P.varies ? '<small>dès</small> ' : '';
    if (P.vfOff) return '<span class="cce-pr cce-vfp"' + attrs + '>' + (P.vfStar ? '' : vfTag(P, price)) + '<span class="cce-disc"><b>' + from + money(price - P.vfOff) + ' HT</b><s>' + money(price) + '</s></span></span>';
    if (pct) return '<span class="cce-pr"' + attrs + '><span class="cce-disc"><em class="cce-pct">-' + pct + ' %</em><s>' + money(price) + '</s></span><b>' + from + money(disc(price, pct)) + ' HT</b></span>';
    return '<span class="cce-pr"' + attrs + '>' + from + '<b>' + money(price) + ' HT</b>' + (cmp > price ? '<s>' + money(cmp) + '</s>' : '') + '</span>';
  }
  function vpHtml(v) {
    var pct = pctOf(v.p.id);
    if (v.p.vfOff) return '<span class="cce-vp" data-vpp="' + v.id + '">' + (v.p.vfStar ? '' : vfTag(v.p, v.price)) + '<b>' + money(v.price - v.p.vfOff) + ' HT</b><s>' + money(v.price) + '</s></span>';
    return '<span class="cce-vp" data-vpp="' + v.id + '">' + (pct ? '<em class="cce-pct">-' + pct + ' %</em><s>' + money(v.price) + '</s> ' + money(disc(v.price, pct)) : money(v.price)) + '</span>';
  }
  function refreshPrices() {
    root.querySelectorAll('[data-prp]').forEach(function (el) {
      var id = +el.getAttribute('data-prp'), P = products.filter(function (x) { return x.id === id; })[0], v = el.getAttribute('data-prv') ? byVid[el.getAttribute('data-prv')] : null;
      if (P) el.outerHTML = priceHtml(P, v);
    });
    root.querySelectorAll('[data-vpp]').forEach(function (el) { var v = byVid[el.getAttribute('data-vpp')]; if (v) el.outerHTML = vpHtml(v); });
  }
  function sumLabel(P) { var n = pQty(P); return n ? n + ' ' + (n > 1 ? P.unit[1] : P.unit[0]) : ''; }
  function varRow(v) {
    var q = qty[v.id] || 0;
    return '<div class="cce-v' + (q ? ' on' : '') + '" data-row="' + v.id + '">' +
      (v.p.shades ? (v.img || v.p.vfStar && v.p.img ? '<img src="' + esc(v.img || v.p.img) + '" alt="" loading="lazy" width="30" height="30">' : '<span class="cce-dot"></span>') +
        '<span class="cce-vl"><b>' + esc(v.code) + '</b> ' + esc(v.label) + '</span>'
        : '<span class="cce-vl">' + esc(v.label) + '</span>') +
      vpHtml(v) + stepper(v) + '</div>';
  }
  function pumpOn(x) {
    if (x.key in state.pump) return state.pump[x.key];
    return !(qty[x.sans.id] && !qty[x.avec.id]);
  }
  // L'interrupteur choisit la version que règle le sélecteur ; l'autre version déjà commandée reste affichée à côté.
  function pumpOther(x) {
    var o = pumpOn(x) ? x.sans : x.avec, n = qty[o.id] || 0;
    return n ? '<small class="cce-pumpo">+ ' + n + ' ' + (pumpOn(x) ? 'sans' : 'avec') + ' pompe</small>' : '';
  }
  function pumpRow(x) {
    var on = pumpOn(x), v = on ? x.avec : x.sans, q = qty[v.id] || 0;
    return '<div class="cce-v' + (q ? ' on' : '') + '" data-row="' + v.id + '">' +
      '<span class="cce-vl">' + (x.base ? esc(x.base) + ' ' : '') +
        '<label class="cce-pump"><input type="checkbox" role="switch" data-pump="' + esc(x.key) + '"' + (on ? ' checked' : '') + '><span class="cce-sw"></span>Avec pompe</label>' + pumpOther(x) + '</span>' +
      vpHtml(v) + stepper(v) + '</div>';
  }
  function varRows(P, vars) {
    if (!P.pairs) return vars.map(varRow).join('');
    var done = {};
    return vars.map(function (v) {
      var x = v.pair;
      if (done[x.key]) return '';
      done[x.key] = 1;
      return pumpRow(x);
    }).join('');
  }
  function matches(P, words) {
    if (!words.length) return { all: true };
    var pk = P.key;
    if (words.every(function (w) { return pk.indexOf(w) >= 0; })) return { all: true };
    var vs = P.vars.filter(function (v) { var k = pk + ' ' + v.key; return words.every(function (w) { return k.indexOf(w) >= 0; }); });
    return vs.length ? { vars: vs } : null;
  }
  function productHtml(P, words) {
    var m = matches(P, words);
    if (!m) return '';
    var vars = m.vars || P.vars;
    if (state.only) { vars = vars.filter(function (v) { return qty[v.id]; }); if (!vars.length) return ''; }
    // Un seul format avec / sans pompe : même ligne qu'un produit simple, l'interrupteur sous les arguments.
    var px = P.pairs && P.pairs.length === 1 && !P.pairs[0].base ? P.pairs[0] : null;
    var pv = px && (pumpOn(px) ? px.avec : px.sans);
    // Hors nuances, une variante épuisée disparaît : s'il n'en reste qu'une, le produit s'affiche comme un produit simple.
    var inStock = function (v) { return v.av || qty[v.id]; };
    if (px && !(inStock(px.avec) && inStock(px.sans))) { pv = inStock(px.sans) && !inStock(px.avec) ? px.sans : px.avec; px = null; }
    var live = P.vars;
    if (!P.shades && !P.pairs) {
      live = P.vars.filter(inStock);
      if (!live.length) live = [P.vars[0]];
      vars = vars.filter(function (v) { return live.indexOf(v) >= 0; });
      if (!vars.length) return '';
      if (live.length === 1) pv = live[0];
    }
    var multi = live.length > 1 && !pv;
    var open = !P.shades || P.vfStar || state.open[P.id] || !!words.length || state.only;
    var q = pQty(P);
    var name = esc(P.name) + (P.nh3 ? ' <span class="cce-nh3">- ' + P.nh3 + ' ammoniaque</span>' : '') +
      (P.vfStar ? ' <span class="cce-badge cce-badge--vf">⚡ ' + esc(VF.badge || VF.pastille || 'Vente flash') + '</span>' : P.badge ? ' <span class="cce-badge">' + esc(P.badge) + '</span>' : '');
    var h = '<div class="cce-p' + (q ? ' has' : '') + (P.vfStar ? ' cce-p--vf' : '') + '" data-pid="' + P.id + '"' + (P.vfStar ? ' style="--vf:' + esc(VF.couleur) + '"' : '') + '>' +
      '<div class="cce-ph">' +
        (P.img ? '<img src="' + esc(P.img) + '" alt="" loading="lazy" width="52" height="52">' : '<span class="cce-noimg"></span>') +
        '<div class="cce-pt"><a href="' + esc(P.url) + '" target="_blank" rel="noopener" class="cce-pn" data-ccvf="0">' + name + '</a>' +
          (!P.vfStar && P.desc ? '<span class="cce-pd">' + esc(P.desc) + '</span>' : '') +
        (P.vfStar ? (multi ? '' : priceHtml(P, pv)) + '</div>' : '</div>' + priceHtml(P, pv)) +
        (multi && P.vfStar ? '' : multi ? '<span class="cce-side"><span class="cce-sumq" data-sumq="' + P.id + '">' + sumLabel(P) + '</span>' +
          (P.shades ? '<button type="button" class="cce-fold" data-fold="' + P.id + '" aria-expanded="' + open + '" aria-label="' + (open ? 'Replier' : 'Déplier') + ' les nuances"><svg width="14" height="14" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2.4" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' : '') +
          '</span>' : stepper(pv || P.vars[0])) +
        (P.vfStar ? vfStarHtml() : '') +
        (!P.vfStar && P.args.length ? '<ul class="cce-args">' + P.args.map(function (a) { return '<li>' + esc(a) + '</li>'; }).join('') + '</ul>' : '') +
        (px ? '<span class="cce-pump1"><label class="cce-pump"><input type="checkbox" role="switch" data-pump="' + esc(px.key) + '"' + (pumpOn(px) ? ' checked' : '') + '><span class="cce-sw"></span>Avec pompe</label>' + pumpOther(px) + '</span>' : '') +
      '</div>';
    if (multi && open) h += '<div class="cce-vs' + (P.shades ? ' cce-shades' : '') + '">' + varRows(P, vars) + '</div>';
    return h + '</div>';
  }
  var SORTS = [['ventes', 'Meilleures ventes'], ['prix', 'Prix croissant'], ['prix-', 'Prix décroissant'], ['nom', 'Nom']];
  function groupHtml(G, words) {
    var sel = state.mf[G.key] || {}, sort = state.ms[G.key] || 'ventes';
    var list = G.list.filter(function (P) {
      return Object.keys(sel).every(function (k) { return !sel[k].length || (P.f[k] || []).some(function (v) { return sel[k].indexOf(v) >= 0; }); });
    }).slice();
    if (sort === 'prix') list.sort(function (a, b) { return a.min - b.min; });
    else if (sort === 'prix-') list.sort(function (a, b) { return b.min - a.min; });
    else if (sort === 'nom') list.sort(function (a, b) { return a.name.localeCompare(b.name, 'fr'); });
    var body = list.map(function (P) { return productHtml(P, words); }).join('');
    if (!body && (words.length || state.only)) return '';
    // Filtres : seulement ceux qui départagent vraiment les produits de la catégorie.
    var facs = FACS.map(function (F) {
      var count = {}, withV = 0;
      G.list.forEach(function (P) { var vs = P.f[F.k] || []; if (vs.length) withV++; vs.forEach(function (v) { count[v] = (count[v] || 0) + 1; }); });
      var vals = Object.keys(count).sort(function (a, b) { return count[b] - count[a] || a.localeCompare(b, 'fr'); });
      if (vals.length < 2 && !(vals.length === 1 && withV < G.list.length)) return '';
      return '<div class="cce-fg"><span class="cce-fl">' + esc(F.l) + '</span><div class="cce-fo">' + vals.map(function (v) {
        var on = (sel[F.k] || []).indexOf(v) >= 0;
        return '<button type="button" class="cce-fv' + (on ? ' on' : '') + '" data-mf="' + esc(G.key) + '" data-k="' + F.k + '" data-v="' + esc(v) + '" aria-pressed="' + on + '"><i></i>' + esc(v) + '</button>';
      }).join('') + '</div></div>';
    }).join('');
    return '<div class="cce-grp2"><div class="cce-gh"><h3>' + esc(G.title) + '</h3>' +
      '<label class="cce-sort"><span>Trier</span><select data-ms="' + esc(G.key) + '">' + SORTS.map(function (o) { return '<option value="' + o[0] + '"' + (o[0] === sort ? ' selected' : '') + '>' + o[1] + '</option>'; }).join('') + '</select></label></div>' +
      (facs ? '<div class="cce-facs">' + facs + '</div>' : '') +
      (body || '<p class="cce-empty">Aucun produit avec ces filtres.</p>') + '</div>';
  }
  // Mobile : « Promos et nouveautés » passe au-dessus de la recherche (la liste complète reste dessous).
  var splitMq = window.matchMedia('(max-width: 989px)'), pinFilter = false;
  function renderList() {
    var words = norm(state.q).split(' ').filter(Boolean);
    var h = '', hi = '', split = splitMq.matches;
    var anchor = root.querySelector('.cce-chips'), before = anchor ? anchor.getBoundingClientRect().top : 0;
    sections.forEach(function (S) {
      if (state.sec !== 'all' && state.sec !== S.key) return;
      if (S.hi && (words.length || state.only) && state.sec === 'all') return;
      var body = S.groups ? S.groups.map(function (G) { return groupHtml(G, words); }).join('')
        : S.list.map(function (P) { return productHtml(P, words); }).join('');
      if (!body) return;
      var sec = '<section class="cce-sec' + (S.hi ? ' cce-hi' : '') + '"><h2>' + esc(S.title) +
        (S.key === 'Colorations' ? ' <span class="cce-tubes" data-tubes>' + tubesLabel() + '</span>' : '') + '</h2>' + body + '</section>';
      if (S.hi && split) hi += sec; else h += sec;
    });
    var hiBox = root.querySelector('[data-cce-hi]');
    if (hiBox) hiBox.innerHTML = hi;
    root.querySelector('[data-cce-list]').innerHTML = h || (state.only
      ? '<div class="cce-mine0"><b>Votre commande est vide</b><p>Ajoutez des produits avec le bouton + dans « Tous les produits », ou prenez votre liste en photo.</p><button type="button" class="cce-btn2" data-cce-tab="all">Voir tous les produits</button></div>'
      : '<p class="cce-empty">Aucun produit ne correspond.</p>');
    // La recherche ne doit pas sauter quand les promos apparaissent ou disparaissent au-dessus d'elle.
    if (split && anchor && pinFilter) { var shift = anchor.getBoundingClientRect().top - before; if (Math.abs(shift) > 1) window.scrollBy(0, shift); }
    pinFilter = false;
    schedule();
  }
  if (splitMq.addEventListener) splitMq.addEventListener('change', function () { renderList(); });
  // Total des tubes commandés, toutes gammes de coloration confondues (produits à nuances de la rubrique).
  function tubesLabel() {
    var S = sections.filter(function (x) { return x.key === 'Colorations'; })[0], n = 0;
    if (S) S.list.forEach(function (P) { if (P.shades) n += pQty(P); });
    return n ? n + (n > 1 ? ' tubes' : ' tube') : '';
  }
  // « Tous les produits » / « Ma commande » (ex-case « Afficher uniquement… »), avec le nombre d'articles choisis.
  var lastCount = 0;
  function renderChips() {
    state.sec = 'all';
    root.querySelector('[data-cce-chips]').innerHTML = '<div class="cce-tabs" role="tablist">' +
      '<button type="button" role="tab" class="cce-tab' + (state.only ? '' : ' on') + '" aria-selected="' + !state.only + '" data-cce-tab="all">Tous les produits</button>' +
      '<button type="button" role="tab" class="cce-tab' + (state.only ? ' on' : '') + '" aria-selected="' + state.only + '" data-cce-tab="mine">Ma commande <span class="cce-tabn' + (lastCount ? '' : ' z') + '" data-cce-tabn>' + lastCount + '</span></button></div>';
  }
  function setTab(mine) {
    var chips = root.querySelector('[data-cce-chips]'), list = root.querySelector('[data-cce-list]');
    var stuck = chips.classList.contains('stuck');
    state.only = mine; pinFilter = true;
    renderChips(); renderList();
    // Onglet changé en cours de liste : on repart du haut de la liste, juste sous les onglets.
    if (stuck) window.scrollTo(0, Math.max(0, list.getBoundingClientRect().top + window.scrollY - chips.offsetHeight - (parseFloat(getComputedStyle(root).getPropertyValue('--cce-htop')) || 0) - 4));
    T('express', 'onglet', mine ? 'ma_commande' : 'tous', { articles: lastCount });
  }
  function visibleLines() { return cart ? cart.items.filter(function (i) { return i.variant_id !== GASOIL && !HIDDEN.some(function (h) { return i.handle && i.handle.indexOf(h) >= 0; }); }) : []; }
  // Récap immédiat : le panier Shopify corrigé par les quantités saisies qui ne sont pas encore enregistrées.
  function effectiveLines() {
    var seen = {}, out = [];
    visibleLines().forEach(function (i) {
      if (!byVid[i.variant_id]) { out.push(i); return; }
      if (seen[i.variant_id]) return;
      seen[i.variant_id] = 1;
      var q = qty[i.variant_id] || 0;
      if (!q) return;
      if (q === i.quantity) { out.push(i); return; }
      var unit = i.quantity ? i.final_line_price / i.quantity : byVid[i.variant_id].price;
      var ounit = i.quantity ? i.original_line_price / i.quantity : byVid[i.variant_id].price;
      out.push(Object.assign({}, i, { quantity: q, final_line_price: Math.round(unit * q), original_line_price: Math.round(ounit * q) }));
    });
    Object.keys(qty).forEach(function (vid) {
      var v = byVid[vid];
      if (seen[vid] || !v || !qty[vid]) return;
      out.unshift({ variant_id: +vid, quantity: qty[vid], final_line_price: unitPrice(v) * qty[vid], original_line_price: v.price * qty[vid], product_title: v.p.name, variant_title: v.label });
    });
    return out;
  }
  function renderSum() {
    var items = effectiveLines();
    var count = items.reduce(function (a, i) { return a + i.quantity; }, 0);
    lastCount = count;
    var tabn = root.querySelector('[data-cce-tabn]');
    if (tabn) { tabn.textContent = count; tabn.classList.toggle('z', !count); }
    var cartLevel = cart ? (cart.cart_level_discount_applications || []).reduce(function (a, d) { return a + (d.total_allocated_amount || 0); }, 0) : 0;
    var sub = items.reduce(function (a, i) { return a + i.final_line_price; }, 0) - cartLevel;
    var left = FRANCO - sub;
    var ship = !count ? '' : left > 0
      ? '<div class="cce-fs"><p>Plus que <b>' + money(left) + ' HT</b> pour la livraison offerte</p><i><b style="width:' + Math.min(100, sub / FRANCO * 100) + '%"></b></i></div>'
      : '<div class="cce-fs done"><p><b>Livraison offerte</b> <s>' + money(SHIP_COST) + ' HT</s></p><i><b style="width:100%"></b></i></div>';
    // Les nuances ou variantes d'un même produit sont regroupées sous une ligne produit, dépliable.
    var groups = [], byPid = {};
    items.forEach(function (i) {
      var v = byVid[i.variant_id];
      var key = v ? 'p' + v.p.id : 'v' + i.variant_id + ':' + groups.length;
      if (!byPid[key]) { byPid[key] = { v: v, items: [] }; groups.push(byPid[key]); }
      byPid[key].items.push(i);
    });
    // Remise automatique du panier : pastille « -10 % », prix barré puis prix remisé.
    function amount(orig, fin) {
      if (!fin) return 'Offert';
      if (!(orig > fin)) return money(fin);
      return '<em class="cce-pct">-' + Math.round((1 - fin / orig) * 100) + ' %</em><s>' + money(orig) + '</s>' + money(fin);
    }
    function line(i) {
      var v = byVid[i.variant_id];
      var sub2 = v && v.p.shades ? (v.code + ' ' + v.label) : (i.variant_title && !/default/i.test(i.variant_title) ? cleanVariant(i.variant_title) : '');
      return '<li><span class="q">' + i.quantity + '×</span><span class="n"><b>' + esc(v ? v.p.name : i.product_title) + '</b>' + (sub2 ? '<small>' + esc(sub2) + '</small>' : '') + '</span><span class="t">' + amount(i.original_line_price, i.final_line_price) + '</span></li>';
    }
    var lines = groups.map(function (g) {
      if (!g.v || (!g.v.p.shades && g.items.length < 2)) return line(g.items[0]);
      var P = g.v.p, n = 0, tot = 0, orig = 0;
      g.items.forEach(function (i) { n += i.quantity; tot += i.final_line_price; orig += i.original_line_price || i.final_line_price; });
      var open = !!state.sumOpen[P.id];
      return '<li class="cce-grp"><span class="q">' + n + '×</span><span class="n"><b>' + esc(P.name) + '</b><small>' + g.items.length + (P.shades ? (g.items.length > 1 ? ' nuances' : ' nuance') : ' variantes') + '</small></span><span class="t">' + amount(orig, tot) + '</span>' +
        '<button type="button" class="cce-gfold" data-sumfold="' + P.id + '" aria-expanded="' + open + '" aria-label="' + (open ? 'Replier' : 'Déplier') + ' le détail"><svg width="12" height="12" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2.6" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' +
        (open ? '<ul class="cce-sub">' + g.items.map(function (i) {
          var v = byVid[i.variant_id];
          return '<li><span class="q">' + i.quantity + '×</span><span class="n">' + esc(P.shades ? v.code + ' ' + v.label : v.label) + '</span><span class="t">' + amount(i.original_line_price, i.final_line_price) + '</span></li>';
        }).join('') + '</ul>' : '') + '</li>';
    }).join('');
    root.querySelector('[data-cce-sum]').innerHTML =
      '<div class="cce-sh"><h2>Commande</h2><span>' + (count ? count + (count > 1 ? ' articles' : ' article') : 'vide') + '</span>' + (count ? '<button type="button" data-cce-clear>Tout vider</button>' : '') + '</div>' +
      (count ? '<ul class="cce-lines">' + lines + '</ul><div class="cce-tot"><span>Total</span><b>' + money(sub) + ' HT</b></div>' + ship +
        '<button type="button" class="cce-go" data-cce-go>Ajouter au panier</button>'
        : '<p class="cce-note">Tapez les quantités dans la liste, elles arrivent ici.</p>');
    root.querySelector('[data-cce-bar]').innerHTML = count
      ? '<div class="cce-bar-in"><span><b>' + money(sub) + ' HT</b><small>' + count + (count > 1 ? ' articles' : ' article') + '</small></span><button type="button" class="cce-go" data-cce-go>Ajouter au panier</button></div>' : '';
  }
  // Met à jour les lignes affichées d'une variante sans tout redessiner (le curseur reste où il est).
  function refreshVariant(vid) {
    var v = byVid[vid], q = qty[vid] || 0;
    root.querySelectorAll('[data-step="' + vid + '"]').forEach(function (el) {
      el.classList.toggle('on', q > 0);
      el.querySelector('[data-d="-1"]').disabled = !q;
      if (maxOf(v)) el.querySelector('[data-d="1"]').disabled = q >= maxOf(v);
      var inp = el.querySelector('input');
      if (document.activeElement !== inp || (maxOf(v) && +inp.value > maxOf(v))) inp.value = q;
    });
    root.querySelectorAll('[data-row="' + vid + '"]').forEach(function (el) { el.classList.toggle('on', q > 0); });
    if (!v) return;
    if (v.pair && !root.querySelector('[data-step="' + vid + '"]')) renderList();
    root.querySelectorAll('[data-pid="' + v.p.id + '"]').forEach(function (el) { el.classList.toggle('has', pQty(v.p) > 0); });
    root.querySelectorAll('[data-sumq="' + v.p.id + '"]').forEach(function (el) { el.textContent = sumLabel(v.p); });
    root.querySelectorAll('[data-tubes]').forEach(function (el) { el.textContent = tubesLabel(); });
    if (PROMO.some(function (pg) { return pg.productIds.indexOf(v.p.id) >= 0; })) {
      var pct = pctOf(v.p.id), was = lastPct[v.p.id] || 0;
      if (pct !== was && vid in pending) T('express', pct > was ? 'palier_atteint' : 'palier_perdu', v.p.name, { pct: pct, avant: was });
      PROMO.forEach(function (pg) { if (pg.productIds.indexOf(v.p.id) >= 0) pg.productIds.forEach(function (id) { lastPct[id] = pctOf(id); }); });
      refreshPrices();
    }
  }

  /* ---------- panier ---------- */
  // Les apps de panier (Corner Cart…) écoutent le fetch de la page et s'ouvrent à chaque mise à jour :
  // on passe par le fetch d'une iframe vierge, qu'elles ne surveillent pas. Le panier ne s'ouvre qu'au clic sur le bouton.
  var quietFetch = null;
  function cleanFetch() {
    if (quietFetch) return quietFetch;
    try {
      var f = document.createElement('iframe');
      f.hidden = true; f.setAttribute('aria-hidden', 'true'); f.tabIndex = -1;
      document.body.appendChild(f);
      quietFetch = f.contentWindow.fetch.bind(f.contentWindow);
    } catch (e) { quietFetch = fetch.bind(window); }
    return quietFetch;
  }
  function api(path, body) {
    var o = { headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, credentials: 'same-origin' };
    if (body) { o.method = 'POST'; o.body = JSON.stringify(body); }
    return cleanFetch()(location.origin + path, o).then(function (r) { return r.json(); });
  }
  function loadCart() {
    return api('/cart.js?cce=' + Date.now()).then(function (c) {
      cart = c;
      var fresh = {};
      c.items.forEach(function (i) { if (byVid[i.variant_id]) fresh[i.variant_id] = (fresh[i.variant_id] || 0) + i.quantity; });
      Object.keys(pending).forEach(function (vid) { fresh[vid] = pending[vid]; });
      // Quantités préparées depuis la photo, affichées mais pas encore dans le panier.
      Object.keys(draft).forEach(function (vid) { if (!(vid in pending)) fresh[vid] = draft[vid]; });
      var changed = Object.keys(Object.assign({}, qty, fresh)).filter(function (vid) { return (qty[vid] || 0) !== (fresh[vid] || 0); });
      qty = fresh;
      changed.forEach(refreshVariant);
      renderSum(); renderChips();
    });
  }
  var pending = {}, draft = {}, timer = null, saving = null;
  function setQty(vid, n) {
    n = capQ(vid, Math.max(0, Math.min(999, parseInt(n, 10) || 0)));
    if ((qty[vid] || 0) === n) { refreshVariant(vid); return; }
    if (n) qty[vid] = n; else delete qty[vid];
    delete draft[vid];
    pending[vid] = n;
    refreshVariant(vid);
    renderChips();
    renderSum();
    clearTimeout(timer);
    timer = setTimeout(flush, 250);
  }
  function flush() {
    if (saving) { timer = setTimeout(flush, 200); return; }
    var updates = pending; pending = {};
    if (!Object.keys(updates).length) return;
    saving = api('/cart/update.js', { updates: updates })
      .catch(function () {})
      .then(loadCart)
      .then(function () { saving = null; });
  }

  /* ---------- événements ---------- */
  root.addEventListener('click', function (e) {
    var b = e.target.closest('button, a');
    if (!b) return;
    if (b.dataset.cceTab) { if ((b.dataset.cceTab === 'mine') !== state.only) setTab(b.dataset.cceTab === 'mine'); return; }
    if (b.dataset.d) {
      var st = b.closest('[data-step]'), vid = st.dataset.step;
      setQty(vid, (qty[vid] || 0) + (+b.dataset.d));
    } else if (b.dataset.fold) {
      state.open[b.dataset.fold] = !state.open[b.dataset.fold];
      try { localStorage.setItem('cce-open', JSON.stringify(state.open)); } catch (err) {}
      renderList();
    } else if (b.dataset.mf) {
      var g = state.mf[b.dataset.mf] = state.mf[b.dataset.mf] || {}, arr = g[b.dataset.k] = g[b.dataset.k] || [];
      var ix = arr.indexOf(b.dataset.v);
      if (ix >= 0) arr.splice(ix, 1); else arr.push(b.dataset.v);
      renderList();
    } else if (b.dataset.sumfold) {
      state.sumOpen[b.dataset.sumfold] = !state.sumOpen[b.dataset.sumfold];
      renderSum();
    } else if (b.dataset.sec) {
      state.sec = b.dataset.sec; renderChips(); renderList();
      root.querySelector('[data-cce-list]').scrollIntoView({ block: 'start', behavior: 'smooth' });
    } else if (b.hasAttribute('data-cce-go')) {
      clearTimeout(timer);
      Object.keys(draft).forEach(function (vid) { pending[vid] = draft[vid]; });
      draft = {};
      Promise.resolve(saving).then(function () { flush(); return saving; }).then(function () {
        var d = crmClient();
        var own = false; try { own = !!cart && sessionStorage.getItem('cc_crm_cart') === String(cart.token || '').split('?')[0]; } catch (e) {}
        if (window.ccCart) window.ccCart.open();
        else location.assign(d && own ? crmCheckoutUrl(d) : '/cart');
      });
    } else if (b.hasAttribute('data-cce-clear')) {
      if (!confirm('Vider toute la commande ?')) return;
      visibleLines().forEach(function (i) { if (byVid[i.variant_id]) setQty(i.variant_id, 0); });
      Object.keys(draft).forEach(function (vid) { setQty(vid, 0); });
    }
  });
  root.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches('[data-ms]')) { state.ms[t.dataset.ms] = t.value; renderList(); return; }
    if (t.matches('[data-pump]')) {
      state.pump[t.dataset.pump] = t.checked;
      renderList();
      return;
    }
    var st = t.closest('[data-step]');
    if (st) setQty(st.dataset.step, t.value);
  });
  root.addEventListener('keydown', function (e) {
    var st = e.target.closest('[data-step]');
    if (!st) return;
    if (e.key === 'Enter') { setQty(st.dataset.step, e.target.value); e.preventDefault(); }
    else if (e.key === 'ArrowUp' || e.key === 'ArrowDown') { e.preventDefault(); setQty(st.dataset.step, (qty[st.dataset.step] || 0) + (e.key === 'ArrowUp' ? 1 : -1)); e.target.value = qty[st.dataset.step] || 0; }
  });
  root.addEventListener('focusin', function (e) { if (e.target.matches('[data-step] input')) e.target.select(); });
  var qTimer;
  var qEl = root.querySelector('[data-cce-q]');
  if (qEl) {
  qEl.addEventListener('input', function (e) {
    clearTimeout(qTimer);
    qTimer = setTimeout(function () { state.q = e.target.value; pinFilter = true; renderList(); }, 150);
  });
  qEl.addEventListener('keydown', function (e) { if (e.key === 'Escape') { e.target.value = ''; state.q = ''; pinFilter = true; renderList(); } });
  }
  // Le panier peut changer ailleurs (tiroir, autre onglet) : on se recale en revenant sur la page.
  document.addEventListener('visibilitychange', function () { if (!document.hidden) loadCart(); });
  // Modifications faites par le tiroir panier ou une autre app : on se recale.
  if (window.PerformanceObserver) {
    var extTimer;
    new PerformanceObserver(function (list) {
      if (!list.getEntries().some(function (x) { return /\/cart\/(add|change|update|clear)(\.js)?/.test(x.name); })) return;
      clearTimeout(extTimer);
      extTimer = setTimeout(function () { if (!saving && !Object.keys(pending).length) loadCart(); }, 700);
    }).observe({ entryTypes: ['resource'] });
  }

  // Le récap colle sous l'en-tête, qui se cache quand on descend : on suit sa position.
  var head = document.querySelector('.ccm-section') || document.querySelector('.section-header');
  var sumEl = root.querySelector('[data-cce-sum]'), placing = false;
  function placeSum() {
    placing = false;
    var top = (head && !head.classList.contains('ccm-hide') && !head.classList.contains('shopify-section-header-hidden') ? Math.max(0, head.getBoundingClientRect().bottom) : 0) + 16;
    root.style.setProperty('--cce-top', top + 'px');
    root.style.setProperty('--cce-htop', (top - 16) + 'px');
    var ch = root.querySelector('[data-cce-chips]');
    if (ch) ch.classList.toggle('stuck', getComputedStyle(ch).position === 'sticky' && ch.getBoundingClientRect().top <= top - 15);
    // Tant qu'il n'est pas encore collé, le récap commence plus bas : sa hauteur suit ce qui reste d'écran.
    var at = Math.max(top, sumEl.getBoundingClientRect().top);
    root.style.setProperty('--cce-max', Math.max(240, window.innerHeight - at - 16) + 'px');
  }
  function schedule() { if (!placing) { placing = true; requestAnimationFrame(placeSum); } }
  if (head) new MutationObserver(function () { setTimeout(placeSum, 260); schedule(); }).observe(head, { attributes: true, attributeFilter: ['class'] });
  window.addEventListener('resize', schedule);
  window.addEventListener('scroll', schedule, { passive: true });
  placeSum();


  /* ---------- pré-saisie depuis une photo ---------- */
  // Photo → lecture → questions (une à la fois) → quantités ajoutées dans la liste. Rien n'est validé ni payé ici.
  (function () {
    var box = root.querySelector('[data-ccp]');
    if (!box) return;
    var file = box.querySelector('[data-ccp-file]'), cam = box.querySelector('[data-ccp-camfile]');
    var MAX_FILES = 5, MAX_BYTES = 15 * 1024 * 1024, MAX_SIDE = 1600;
    var REDUCE = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    var panel = null, run = null;

    /* Produits utiles, retrouvés dans le catalogue de la page (jamais d'id venant d'ailleurs sans contrôle). */
    var ID = { color: 8867416932679, zero: 9818506363207, gloss: 9516681756999, light: 10726397608263, oxy: 8426543710535,
      fullblond: 11067806777671, easyblond: 8370638356807 };
    var keyOfPid = {};
    Object.keys(ID).forEach(function (k) { keyOfPid[ID[k]] = k; });
    var byId = {};
    products.forEach(function (P) { byId[P.id] = P; });
    function prod(k) { return byId[ID[k]] || null; }
    function shade(k, code) { var P = prod(k); return P ? P.vars.filter(function (v) { return v.code === code; })[0] || null : null; }
    function oxyVar(vol) { var P = prod('oxy'); return P ? P.vars.filter(function (v) { return new RegExp('^' + vol + ' vol').test(v.label); })[0] || null : null; }

    /* Dosages des fiches produit : ml d'oxydant par unité, et force conseillée (EasyOxy en bouteille de 1 L).
       Light : 10 vol uniquement. Gloss : 5 vol uniquement. Colorations et décolorations : « selon le diagnostic », 20 vol proposé par défaut. */
    var OXY_NEED = { color: [150, 20], zero: [150, 20], gloss: [90, 5], light: [90, 10], fullblond: [750, 20], easyblond: [1000, 20] };

    /* ---------- lecture : fonction serveur express-photo-api (marketing-factory) ---------- */
    // La réponse ne contient que des lignes contrôlées contre le catalogue : nuance (gamme + code), poudre, oxydant,
    // id de variante, ou « non reconnu ». On revérifie quand même ici que chaque id existe dans la page.
    var API = 'https://hfgehqbswyeiqxxksbhx.supabase.co/functions/v1/express-photo-api';
    // Turnstile : jeton à usage unique prouvant qu'un vrai navigateur a chargé la page, demandé pendant la préparation
    // des photos. Invisible, sauf si Cloudflare exige une case à cocher (alors affichée sous la barre de lecture).
    var TS_KEY = box.getAttribute('data-turnstile'), tsWidget = null;
    function tsToken() {
      return new Promise(function (res, rej) {
        if (!TS_KEY) return res('');
        var host = panel && panel.querySelector('[data-ccx-ts]');
        var fail = function () { rej({ msg: 'La vérification du navigateur a échoué : rechargez la page et réessayez.' }); };
        var t0 = Date.now(), timer = setTimeout(fail, 30000);
        (function wait() {
          if (!window.turnstile) return Date.now() - t0 < 8000 ? setTimeout(wait, 100) : (clearTimeout(timer), fail());
          if (!host) { clearTimeout(timer); return fail(); }
          try { if (tsWidget !== null) window.turnstile.remove(tsWidget); } catch (e) {}
          tsWidget = null;
          try {
            tsWidget = window.turnstile.render(host, { sitekey: TS_KEY, appearance: 'interaction-only',
              callback: function (token) { clearTimeout(timer); res(token); },
              'error-callback': function () { clearTimeout(timer); fail(); } });
          } catch (e) { clearTimeout(timer); fail(); }
        })();
      });
    }
    function analyze(images, token) {
      var ctl = window.AbortController ? new AbortController() : null;
      // Une liste de plusieurs pages se lit plus lentement (3 pages, 79 lignes : 39 s côté serveur) : délai par page.
      var to = setTimeout(function () { if (ctl) ctl.abort(); }, 30000 + 25000 * images.length);
      return fetch(API, { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Turnstile-Token': token }, body: JSON.stringify({ images: images }), signal: ctl && ctl.signal })
        .then(function (r) {
          return r.json().catch(function () { return {}; }).then(function (j) {
            if (!r.ok || !Array.isArray(j.lines)) { var e = new Error('api'); e.msg = typeof j.error === 'string' ? j.error : ''; throw e; }
            return j.lines.map(function (l) {
              if (!l || l.k !== 'choice') return l;
              var c = (l.cands || []).filter(function (v) { return byVid[v]; });
              return c.length > 1 ? { raw: l.raw, q: l.q, k: 'choice', cands: c } : c.length ? { raw: l.raw, q: l.q, k: 'vid', vid: c[0] } : { raw: l.raw, q: l.q, k: 'unknown' };
            }).filter(function (l) { return l && typeof l.raw === 'string' && (l.k !== 'vid' || byVid[l.vid]); }).slice(0, 150);
          });
        })
        .finally(function () { clearTimeout(to); });
    }
    // Questions à poser, déduites des lignes : gamme (colorations sans gamme), nuances en double (5 / 5.00), poudre,
    // puis une question par produit ambigu (« Fiberprotech » : le spray ou le sérum ?).
    // Sur une liste manuscrite on annote l'exception, pas la règle : si une partie des lignes porte une mention
    // (SA ou AA), les lignes sans mention sont de l'autre gamme. Aucune mention, ou les deux à la fois : on demande.
    function impliedGamme(lines) {
      var color = lines.some(function (l) { return l.k === 'color'; }), zero = lines.some(function (l) { return l.k === 'zero'; });
      return color === zero ? '' : color ? 'zero' : 'color';
    }
    function asksFor(lines) {
      var out = [];
      if (lines.some(function (l) { return l.k === 'colo'; }) && !impliedGamme(lines)) out.push('gamme');
      // Même logique pour le double zéro : un « .00 » écrit quelque part signifie que les bases écrites nues sont les nuances nues.
      var explicit00 = lines.some(function (l) { return /^(colo|color|zero)$/.test(l.k) && /\.00$/.test(l.code || ''); });
      // Un seul zéro écrit (« 8,0 ») : le client veut la base simple, sinon il aurait écrit « 8,00 ».
      function singleZero(l) { return new RegExp('(^|[^\\d.,])' + l.code + '\\s*[.,]\\s*0(?!\\d)').test(l.raw || ''); }
      var seen = {};
      lines.forEach(function (l) {
        if (explicit00 || !/^(colo|color|zero)$/.test(l.k) || !/^\d{1,2}$/.test(l.code || '') || singleZero(l)) return;
        var gs = l.k === 'colo' ? ['color', 'zero'] : [l.k];
        if (gs.some(function (g) { return shade(g, l.code) && shade(g, l.code + '.00'); }) && !seen[l.code]) { seen[l.code] = 1; out.push('nuance:' + l.code); }
      });
      if (lines.some(function (l) { return l.k === 'poudre'; })) out.push('poudre');
      lines.forEach(function (l, i) { if (l.k === 'choice') out.push('choix:' + i); });
      return out;
    }

    /* ---------- photos : contrôle et ré-encodage dans le navigateur ---------- */
    // On ne garde que les pixels : l'image est redessinée et ré-exportée en JPEG (aucun fichier d'origine, aucune métadonnée).
    function isHeic(f) { return /hei[cf]/i.test(f.type) || /\.hei[cf]$/i.test(f.name || ''); }
    // HEIC (photos d'iPhone) : Safari sait l'ouvrir, sinon convertisseur du thème chargé à la demande.
    var heicLib = null;
    function loadHeic() {
      if (heicLib) return heicLib;
      heicLib = new Promise(function (res, rej) {
        var sc = document.createElement('script');
        sc.src = box.getAttribute('data-heic');
        sc.onload = function () { window.HeicTo ? res(window.HeicTo) : rej(); };
        sc.onerror = rej;
        document.head.appendChild(sc);
      });
      return heicLib;
    }
    function draw(blob) {
      return new Promise(function (res, rej) {
        var url = URL.createObjectURL(blob), img = new Image();
        img.onload = function () {
          var s = Math.min(1, MAX_SIDE / Math.max(img.naturalWidth, img.naturalHeight)), c = document.createElement('canvas');
          c.width = Math.round(img.naturalWidth * s); c.height = Math.round(img.naturalHeight * s);
          c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
          URL.revokeObjectURL(url);
          res(c.toDataURL('image/jpeg', 0.82));
        };
        img.onerror = function () { URL.revokeObjectURL(url); rej(); };
        img.src = url;
      });
    }
    // PDF : chaque page est dessinée dans le navigateur puis envoyée en JPEG, comme une photo (le serveur ne reçoit jamais le PDF).
    function isPdf(f) { return /pdf/i.test(f.type) || /\.pdf$/i.test(f.name || ''); }
    var pdfLib = null;
    function loadPdf() {
      if (pdfLib) return pdfLib;
      pdfLib = new Promise(function (res, rej) {
        var sc = document.createElement('script');
        sc.src = box.getAttribute('data-pdf');
        sc.onload = function () {
          var L = window.pdfjsLib;
          if (!L) return rej();
          // Le worker vit sur le CDN Shopify (autre origine) : chargé en blob, sinon pdf.js bascule sur son mode sans worker.
          fetch(box.getAttribute('data-pdf-worker')).then(function (r) { return r.blob(); })
            .then(function (b) { L.GlobalWorkerOptions.workerSrc = URL.createObjectURL(b); })
            .catch(function () { L.GlobalWorkerOptions.workerSrc = box.getAttribute('data-pdf-worker'); })
            .then(function () { res(L); });
        };
        sc.onerror = rej;
        document.head.appendChild(sc);
      });
      return pdfLib;
    }
    function pdfPages(f, max) {
      return Promise.all([loadPdf(), f.arrayBuffer()]).then(function (r) {
        // isEvalSupported:false = parade à la CVE-2024-4367 (code exécuté via une police piégée).
        return r[0].getDocument({ data: r[1], isEvalSupported: false }).promise;
      }).then(function (doc) {
        var n = Math.min(doc.numPages, max), out = [], chain = Promise.resolve();
        for (var p = 1; p <= n; p++) (function (p) {
          chain = chain.then(function () { return doc.getPage(p); }).then(function (page) {
            var v0 = page.getViewport({ scale: 1 }), v = page.getViewport({ scale: MAX_SIDE / Math.max(v0.width, v0.height) });
            var c = document.createElement('canvas'), ctx = c.getContext('2d');
            c.width = Math.round(v.width); c.height = Math.round(v.height);
            ctx.fillStyle = '#fff'; ctx.fillRect(0, 0, c.width, c.height);
            return page.render({ canvasContext: ctx, viewport: v }).promise.then(function () { out.push(c.toDataURL('image/jpeg', 0.82)); });
          });
        })(p);
        return chain.then(function () { doc.destroy(); return out; });
      }).catch(function () { return []; });
    }
    // Renvoie toujours une liste d'images : une pour une photo, une par page pour un PDF.
    function reencode(f) {
      if (f.size > MAX_BYTES) return Promise.resolve([]);
      if (isPdf(f)) return pdfPages(f, MAX_FILES);
      if (!(/^image\/(jpeg|png|webp)$/i.test(f.type) || isHeic(f))) return Promise.resolve([]);
      return draw(f).catch(function () {
        if (!isHeic(f)) return null;
        return loadHeic().then(function (h) { return h({ blob: f, type: 'image/jpeg', quality: 0.9 }); })
          .then(draw).catch(function () { return null; });
      }).then(function (d) { return d ? [d] : []; });
    }

    /* ---------- panneau ---------- */
    function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
    // Hauteur fixe pendant tout le déroulé (lecture, validation, questions) : le contenu change, le bloc ne bouge pas.
    function swap(html, after) {
      var inner = panel.querySelector('.ccx-in');
      inner.classList.add('out');
      setTimeout(function () {
        inner.innerHTML = html;
        inner.classList.remove('out');
        if (after) after(inner);
      }, REDUCE ? 0 : 180);
    }
    // Mesure la plus haute vue possible (une question à trois choix) pour figer la hauteur du bloc.
    function lockHeight(nOpts, nUnk) {
      nOpts = Math.max(3, nOpts || 0);
      var opt = '<button type="button" class="ccx-opt"><span class="ccx-noimg"></span><span class="ccx-ol"><b>Coiffissimo Color</b><small>Sachet 500 g · 16,90 € HT</small></span></button>';
      var m = el('div', 'ccx-in ccx-measure', '<div class="ccx-q"><div class="ccx-qh"><span class="ccx-qn">3 questions pour finaliser votre panier</span></div>' +
        '<p class="ccx-qt">Quelle poudre décolorante ?</p><p class="ccx-sub ccx-qsub">Déjà précisé : AA 4.15, 5, 6.1 · SA 7.3. À préciser : 5, 6.1, 7.3</p>' +
        '<div class="ccx-opts' + (nOpts === 3 ? ' three' : '') + '">' + new Array(nOpts + 1).join(opt) + '</div><button type="button" class="ccx-back">Question précédente</button></div>');
      var f = el('div', 'ccx-in ccx-measure', '<div class="ccx-fin">' + CHECK.replace('ccx-ok', 'ccx-ok big') + '<p class="ccx-t">Super, votre commande est prête !</p>' +
        '<p class="ccx-sub">66 produits repérés · 390,00 € HT</p><p class="ccx-note">Oxydants répartis selon vos produits : 10 × 20 vol, 1 × 10 vol, 1 × 5 vol. Shampooings avec pompe.</p>' +
        '<div class="ccx-acts"><button type="button" class="cce-go">Passer ma commande</button><button type="button" class="ccp-cta">Voir le détail</button></div>' +
        (nUnk ? '<div class="ccx-unkbox"><p><b>Attention, 2 lignes non reconnues</b><br>Nous n\'avons pas su les rattacher à un produit : ajoutez-les à la main dans la liste.</p><ul>' + new Array(nUnk + 1).join('<li>Ligne</li>') + '</ul></div>' : '') +
      '</div>');
      panel.appendChild(m); panel.appendChild(f);
      panel.style.minHeight = Math.max(parseFloat(panel.style.minHeight) || 0, Math.max(m.offsetHeight, f.offsetHeight) + 2) + 'px';
      m.remove(); f.remove();
    }
    function openPanel() {
      panel = el('div', 'ccx', '<div class="ccx-in"></div>');
      panel.setAttribute('role', 'region');
      panel.setAttribute('aria-label', 'Préparation de votre panier depuis votre photo');
      box.hidden = true;
      box.parentNode.insertBefore(panel, box.nextSibling);
      lockHeight();
    }
    function closePanel() { if (panel) panel.remove(); panel = null; box.hidden = false; }

    var CHECK = '<svg class="ccx-ok" viewBox="0 0 52 52" aria-hidden="true"><circle cx="26" cy="26" r="24"/><path d="M14.5 27.5l7.5 7.5 16-17"/></svg>';
    var QMARK = '<svg viewBox="0 0 16 16" width="14" height="14" aria-hidden="true"><circle cx="8" cy="8" r="6.5" fill="none" stroke="currentColor" stroke-width="1.8"/><path d="M6.3 6.3a1.8 1.8 0 1 1 2.4 1.7c-.5.2-.7.6-.7 1.1M8 11.3v.1" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>';
    var TICK = '<svg viewBox="0 0 16 16" width="14" height="14" aria-hidden="true"><path d="M3.5 8.5l3 3 6-7" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    // Chaque étape reste affichée au moins STEP_MS ; la dernière s'affiche quand la lecture est finie.
    var STEPS = ['Envoi de la photo', 'Optimisation de l\'image', 'Analyse de la photo', 'Lecture des références', 'Rapprochement avec le catalogue', 'Références validées'];
    var STEP_MS = 1700, LAST_MS = 1200;

    function start(files) {
      var list = [].slice.call(files || []).slice(0, MAX_FILES);
      if (!list.length || run) return;
      T('express', 'photo_envoyee', '', { n: list.length });
      openPanel();
      panel.querySelector('.ccx-in').innerHTML =
        '<div class="ccx-read"><div class="ccx-top">' +
          '<div class="ccx-shots">' + list.map(function () { return '<span class="ccx-shot"><img alt="" hidden><i></i></span>'; }).join('') + '</div>' +
          '<div class="ccx-main">' +
            '<p class="ccx-t">Lecture de votre commande</p>' +
            '<p class="ccx-st" aria-live="polite"><span class="ccx-verb">' + STEPS[0] + '</span><span class="ccx-dots" aria-hidden="true"><i>.</i><i>.</i><i>.</i></span></p>' +
            '<div class="ccx-bar" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="0"><b></b></div>' +
            '<div class="ccx-ts" data-ccx-ts></div>' +
          '</div></div>' +
          '<ul class="ccx-lines" aria-hidden="true"></ul>' +
        '</div>';
      run = { t0: Date.now(), pct: 0, done: false, chips: 0, step: 0, stepAt: Date.now(), lastAt: 0 };
      var bar = panel.querySelector('.ccx-bar'), fill = bar.querySelector('b'), verb = panel.querySelector('.ccx-verb'), chipsEl = panel.querySelector('.ccx-lines');
      function showStep(i) {
        run.step = i; run.stepAt = Date.now();
        if (i === STEPS.length - 1) run.lastAt = run.stepAt;
        verb.classList.add('swap');
        setTimeout(function () { verb.textContent = STEPS[i]; verb.classList.remove('swap'); }, REDUCE ? 0 : 260);
      }
      // Progression : rapide au début, puis de plus en plus lente tant que la réponse n'est pas arrivée (jamais 100 % avant).
      var tick = setInterval(function () {
        var now = Date.now(), t = (now - run.t0) / 1000;
        var held = now - run.stepAt >= STEP_MS;
        if (held && run.step < STEPS.length - 2) showStep(run.step + 1);
        else if (held && run.done && run.step === STEPS.length - 2) showStep(STEPS.length - 1);
        var ending = run.lastAt && now - run.lastAt > LAST_MS / 2;
        var target = ending ? 100 : Math.min(run.done ? 96 : 92, 92 * (1 - Math.exp(-t / 2.6)) + (run.done ? 6 : 0));
        run.pct += (target - run.pct) * (ending ? 0.3 : 0.12);
        fill.style.width = run.pct.toFixed(1) + '%';
        bar.setAttribute('aria-valuenow', Math.round(run.pct));
        // Les lignes lues apparaissent une à une dès que la lecture est revenue.
        if (run.done && run.chips < run.lines.length && now - (run.chipAt || 0) > 90) {
          var ln = run.lines[run.chips++];
          chipsEl.appendChild(el('li', ln.k === 'unknown' ? 'ccx-unk' : '', (ln.k === 'unknown' ? QMARK : TICK) + esc(ln.raw)));
          run.chipAt = now;
        }
        if (run.lastAt && now - run.lastAt > LAST_MS && run.pct > 99.5 && run.chips >= run.lines.length) {
          clearInterval(tick);
          fill.style.width = '100%';
          read();
        }
      }, 60);
      Promise.all([Promise.all(list.map(reencode)), tsToken()]).then(function (r) {
        var perFile = r[0];
        // Vignette = première image de chaque fichier ; envoi = toutes les pages, 5 au plus.
        var shots = panel ? panel.querySelectorAll('.ccx-shot img') : [];
        perFile.forEach(function (ds, i) { if (ds[0] && shots[i]) { shots[i].src = ds[0]; shots[i].hidden = false; } });
        var imgs = [].concat.apply([], perFile).slice(0, MAX_FILES);
        if (!imgs.length) throw new Error('image');
        return analyze(imgs, r[1]);
      }).then(function (lines) {
        // Quantité écrite à zéro (« x0 », « × 0 ») : le client n'en veut pas, la ligne est ignorée.
        // Le serveur renvoie q = 0 aussi quand rien n'est écrit (pris pour 1) : seul le texte lu les distingue.
        lines = lines.filter(function (l) { return !/[×x*:]\s*0+\s*$/i.test(l.raw || ''); });
        run.lines = lines;
        run.result = { lines: lines, ask: asksFor(lines) };
        lockHeight(Math.max.apply(null, [0].concat(lines.map(function (l) { return l.cands ? l.cands.length + (l.q >= l.cands.length ? 1 : 0) : 0; }))),
          lines.filter(function (l) { return l.k === 'unknown'; }).length);
        run.done = true;
        T('express', 'photo_lue', '', { lignes: lines.length, questions: run.result.ask.length, s: Math.round((Date.now() - run.t0) / 100) / 10 });
      }).catch(function (e) {
        clearInterval(tick);
        T('express', 'photo_erreur', '', {});
        fail(e && e.msg);
      });
    }

    function fail(msg) {
      swap('<div class="ccx-err"><p class="ccx-t">' + esc(msg || 'Nous n\'avons pas pu lire cette photo') + '</p><p class="ccx-sub">Reprenez la liste à plat, bien éclairée et en entier, puis réessayez. Vous pouvez aussi remplir les quantités dans la liste ci-dessous.</p>' +
        '<button type="button" class="ccp-cta" data-ccx-retry>Réessayer</button></div>');
      run = null;
    }

    /* ---------- lecture terminée ---------- */
    var ans = {};
    function read() {
      var r = run.result, n = r.lines.filter(function (l) { return l.k !== 'unknown'; }).length, k = r.ask.length;
      swap('<div class="ccx-done">' + CHECK + '<div><p class="ccx-t">' + n + ' lignes lues sur votre photo</p><p class="ccx-sub">' +
        (k ? (k > 1 ? 'Plus que ' + k + ' petites questions' : 'Plus qu\'une petite question') + ' et votre panier est prêt.' : 'Votre panier est prêt.') + '</p></div></div>');
      ans = {};
      setTimeout(function () { k ? ask(0) : finish(); }, REDUCE ? 600 : 1500);
    }

    /* ---------- questions, une à la fois ---------- */
    // « Les deux » poudres : moitié chacune, l'unité en plus sur EASYBLOND (5 = 3 EASYBLOND + 2 FULLBLOND).
    function split2(n) { return [Math.ceil(n / 2), Math.floor(n / 2)]; }
    function poudreQty() { var l = run.result.lines.filter(function (x) { return x.k === 'poudre'; })[0]; return l ? l.q : 0; }
    // Quantité notée assez grande pour en prendre de chaque : « Les deux » / « Un de chaque », réparti au plus juste.
    function splitN(n, k) { var out = []; for (var j = 0; j < k; j++) out.push(Math.floor(n / k) + (j < n % k ? 1 : 0)); return out; }
    function allOpt(L, names) {
      var k = L.cands.length;
      if (!L.q || L.q < k) return [];
      var sp = splitN(L.q, k), pics = '<span class="ccx-duo">' + L.cands.slice(0, 3).map(function (vid) { var v = byVid[vid], im = v.img || v.p.img; return im ? '<img src="' + esc(im) + '" alt="" width="34" height="34">' : ''; }).join('') + '</span>';
      // « 1 de chaque », « 2 de chaque »… quand la quantité se partage juste ; sinon le détail de la répartition.
      var even = sp.every(function (x) { return x === sp[0]; });
      var title = even ? sp[0] + ' de chaque' : k === 2 ? 'Les deux' : 'Un peu de chaque';
      var sub = k === 2 ? (even ? names[0] + ' + ' + names[1] : sp[0] + ' ' + names[0] + ' + ' + sp[1] + ' ' + names[1]) : even ? '' : 'Quantité répartie entre les ' + k;
      return [['all', title, sub, null, null, pics]];
    }
    function hasShade(g, c) { return !!(shade(g, c) || shade(g, c + '.00')); }
    function codeList(cs) { return cs.slice(0, 8).join(', ') + (cs.length > 8 ? ' +' + (cs.length - 8) : ''); }
    function QDEF(id) {
      if (id === 'gamme') {
        // Chaque choix annonce les nuances qu'il ajoute ; une nuance absente de la gamme choisie est prise dans l'autre.
        var todo = [], known = { color: [], zero: [] };
        run.result.lines.forEach(function (l) {
          if (l.k === 'colo') { if (todo.indexOf(l.code) < 0) todo.push(l.code); }
          else if (known[l.k] && known[l.k].indexOf(l.code) < 0) known[l.k].push(l.code);
        });
        var gsub = function (g, label) {
          var other = g === 'color' ? 'zero' : 'color', miss = todo.filter(function (c) { return !hasShade(g, c); });
          var inG = todo.filter(function (c) { return hasShade(g, c); });
          return label + (inG.length ? ' : ' + codeList(inG) : '') + (miss.length ? ' · ' + codeList(miss) + ' en ' + (other === 'color' ? 'Color' : 'Zero') : '');
        };
        var noted = [known.color.length ? 'AA ' + codeList(known.color) : '', known.zero.length ? 'SA ' + codeList(known.zero) : ''].filter(Boolean);
        return {
          text: 'Avec ou sans ammoniaque ?',
          sub: (noted.length ? 'Déjà précisé : ' + noted.join(' · ') + '. ' : '') + 'À préciser : ' + codeList(todo),
          opts: [['color', 'Coiffissimo Color', gsub('color', 'Avec ammoniaque'), prod('color')], ['zero', 'Coiffissimo Zero', gsub('zero', 'Sans ammoniaque'), prod('zero')]]
        };
      }
      if (id.indexOf('nuance:') === 0) {
        var c = id.slice(7), g = ans.gamme || (run.result.lines.filter(function (l) { return l.code === c && /^(color|zero)$/.test(l.k); })[0] || {}).k || impliedGamme(run.result.lines) || 'color';
        var a = shade(g, c), b = shade(g, c + '.00');
        return { text: 'Quelle nuance ' + c + ' ?',
          opts: [[c, c + ' ' + (a ? a.label : ''), '', null, a], [c + '.00', c + '.00 ' + (b ? b.label : ''), '', null, b]] };
      }
      if (id === 'poudre') {
        var n = poudreQty(), sp = split2(n), fb = prod('fullblond'), eb = prod('easyblond');
        var duo = '<span class="ccx-duo">' + [eb, fb].map(function (P) { return P && P.img ? '<img src="' + esc(P.img) + '" alt="" width="34" height="34">' : ''; }).join('') + '</span>';
        return { text: 'Quelle poudre décolorante ?',
          opts: [['fullblond', 'FULLBLOND', 'Sachet 500 g', fb], ['easyblond', 'EASYBLOND', 'Sachet 500 g', eb],
            ['both', 'Les deux', sp[0] + ' EASYBLOND + ' + sp[1] + ' FULLBLOND', null, null, duo]] };
      }
      if (id.indexOf('choix:') === 0) {
        var L = run.result.lines[+id.slice(6)];
        // Nom court du produit ; si deux options portent le même, on prend le début du titre complet.
        var short = function (v) { return String(v.p.name || v.p.t).trim(); };
        var names = L.cands.map(function (vid) { return short(byVid[vid]); });
        return { text: '« ' + L.raw + ' » : quel produit ?',
          opts: L.cands.map(function (vid, j) {
            var v = byVid[vid], name = names.indexOf(names[j]) !== names.lastIndexOf(names[j]) ? String(v.p.t).split(/ [-–] /)[0].replace(/\s+/g, ' ') : names[j];
            // Sous le nom : le descriptif court du produit, précédé de la variante (taille…) si elle n'y figure pas déjà.
            // La pompe est un choix par défaut, pas une question : jamais affichée dans les options.
            var vl = /default/i.test(v.label) ? '' : v.label.replace(/\s*[-\/]?\s*\b(avec|sans) pompe\b\s*[-\/]?\s*/i, ' ').trim(), d = v.p.desc || '';
            var sub = vl && norm(d).replace(/\s/g, '').indexOf(norm(vl).replace(/\s/g, '')) < 0 ? [vl, d].filter(Boolean).join(' · ') : (d || vl);
            return [vid, (L.q > 1 ? L.q + ' × ' : '') + name, sub, null, { img: v.img || v.p.img, price: v.price }];
          }).concat(allOpt(L, names)) };
      }
    }
    function ask(i) {
      var ids = run.result.ask, id = ids[i], Q = QDEF(id);
      var dots = ids.map(function (_, j) { return '<i class="' + (j < i ? 'on' : j === i ? 'cur' : '') + '"></i>'; }).join('');
      var tiles = Q.opts.map(function (o) {
        var img = o[4] ? o[4].img : o[3] ? o[3].img : '';
        var pic = o[5] || (img ? '<img src="' + esc(img) + '" alt="" width="44" height="44">' : '<span class="ccx-noimg"></span>');
        return '<button type="button" class="ccx-opt' + (ans[id] === o[0] ? ' sel' : '') + '" data-ccx-q="' + id + '" data-ccx-v="' + esc(o[0]) + '">' +
          pic +
          '<span class="ccx-ol"><b>' + esc(o[1]) + '</b>' + (o[2] ? '<small>' + esc(o[2]) + '</small>' : '') + '</span>' +
          '</button>';
      }).join('');
      swap('<div class="ccx-q" data-step="' + i + '">' +
        '<div class="ccx-qh"><span class="ccx-qn">' + ids.length + (ids.length > 1 ? ' questions' : ' question') + ' pour finaliser votre panier</span><span class="ccx-steps" aria-label="Question ' + (i + 1) + ' sur ' + ids.length + '">' + dots + '</span></div>' +
        '<p class="ccx-qt">' + esc(Q.text) + '</p>' +
        (Q.sub ? '<p class="ccx-sub ccx-qsub">' + esc(Q.sub) + '</p>' : '') +
        '<div class="ccx-opts' + (Q.opts.length === 3 ? ' three' : '') + '">' + tiles + '</div>' +
        (i ? '<button type="button" class="ccx-back" data-ccx-back="' + (i - 1) + '">Question précédente</button>' : '') +
      '</div>');
    }
    function answer(id, v) {
      ans[id] = v;
      var ids = run.result.ask, i = ids.indexOf(id);
      T('express', 'photo_reponse', id, { v: v });
      setTimeout(function () { i < ids.length - 1 ? ask(i + 1) : finish(); }, REDUCE ? 80 : 320);
    }

    /* ---------- panier : lignes lues + réponses + valeurs par défaut ---------- */
    function build() {
      var out = {}, need = { 5: 0, 10: 0, 20: 0 }, oxyQty = null, oxyAsked = false;
      // Code à prendre pour une nuance : la réponse à « Quelle nuance 5 ? » si la question a été posée.
      function code(l) { return ans['nuance:' + l.code] || l.code; }
      function add(v, n, kNeed) {
        if (!v || !n) return;
        out[v.id] = (out[v.id] || 0) + n;
        var o = OXY_NEED[kNeed];
        if (o) need[o[1]] += o[0] * n;
      }
      run.result.lines.forEach(function (l, i) {
        var q = l.q || 1;
        if (l.k === 'colo') {
          var g = ans.gamme || impliedGamme(run.result.lines), s = shade(g, code(l));
          if (!s) { g = g === 'color' ? 'zero' : 'color'; s = shade(g, code(l)); }
          add(s, q, g);
        }
        else if (/^(color|zero|gloss|light)$/.test(l.k)) add(shade(l.k, code(l)), q, l.k);
        else if (l.k === 'poudre') {
          if (ans.poudre === 'both') { var sp = split2(q); add(prod('easyblond') && prod('easyblond').vars[0], sp[0], 'easyblond'); add(prod('fullblond') && prod('fullblond').vars[0], sp[1], 'fullblond'); }
          else { var P = prod(ans.poudre); add(P && P.vars[0], q, ans.poudre); }
        }
        // Oxydant avec son volume écrit : pris tel quel. Sans volume : réparti selon les produits (plus bas).
        else if (l.k === 'oxy' && l.vol) add(oxyVar(l.vol), q);
        else if (l.k === 'oxy') { oxyAsked = true; oxyQty = (oxyQty || 0) + l.q || null; }
        else if (l.k === 'vid') { var v = byVid[l.vid]; add(v, q, v && keyOfPid[v.p.id]); }
        else if (l.k === 'choice' && ans['choix:' + i] === 'all') splitN(q, l.cands.length).forEach(function (n, j) { var w = byVid[l.cands[j]]; add(w, n, w && keyOfPid[w.p.id]); });
        else if (l.k === 'choice') { var w = byVid[ans['choix:' + i]]; add(w, q, w && keyOfPid[w.p.id]); }      });
      // Oxydant écrit sans volume : quantité notée répartie au prorata des besoins ; sans quantité, assez de bouteilles de 1 L.
      // Jamais d'oxydant s'il n'est pas sur la liste : rien n'est ajouté au panier qui n'y soit pas écrit.
      var vols = [20, 10, 5].filter(function (v) { return need[v] > 0; }), split = {};
      var total = vols.reduce(function (a, v) { return a + need[v]; }, 0);
      if (total && oxyAsked) {
        if (oxyQty == null) vols.forEach(function (v) { split[v] = Math.ceil(need[v] / 1000); });
        else {
          var rest = oxyQty, parts = vols.map(function (v) { var x = oxyQty * need[v] / total; return { v: v, n: Math.max(1, Math.floor(x)), r: x - Math.floor(x) }; });
          rest -= parts.reduce(function (a, p) { return a + p.n; }, 0);
          parts.sort(function (a, b) { return b.r - a.r; });
          for (var j = 0; rest > 0; j = (j + 1) % parts.length, rest--) parts[j].n++;
          for (j = parts.length - 1; rest < 0 && j >= 0; j--) while (rest < 0 && parts[j].n > 1) { parts[j].n--; rest++; }
          parts.forEach(function (p) { split[p.v] = p.n; });
        }
        Object.keys(split).forEach(function (v) { add(oxyVar(v), split[v]); });
      }
      return { qty: out, split: split };
    }

    /* ---------- remplacements d'une ligne non reconnue : proposés, jamais ajoutés sans clic ---------- */
    function altVar(a) { var m = String(a).match(/^(color|zero|gloss|light):(.+)$/); return m ? shade(m[1], m[2]) : byVid[a]; }
    function altName(v) {
      var n = String(v.p.name || v.p.t).split(' - ')[0];
      return v.p.shades ? n + ' ' + v.code + ' ' + v.label : /default/i.test(v.label) ? n : n + ' ' + v.label;
    }
    function altsHtml(l) {
      var vs = (l.alts || []).map(altVar).filter(Boolean);
      if (!vs.length) return '<li>' + esc(l.raw) + '</li>';
      if (l.oos) {
        // Rien n'est remplacé d'office : le client choisit, à la quantité qu'il avait demandée.
        var n = l.q || 1;
        return '<li>' + esc(l.raw) + '<div class="ccx-alts"><span>En attendant, nous vous proposons :</span>' + vs.map(function (v) {
          return '<button type="button" class="ccx-alt" data-ccx-alt="' + v.id + '" data-ccx-n="' + n + '">+ ' + esc(altName(v)) + ' × ' + n + '</button>';
        }).join('') + '</div></li>';
      }
      var lead = vs[0].p.shades ? 'Cette nuance n\'existe pas chez nous, les plus proches :' : 'Nous ne l\'avons pas, à la place :';
      return '<li>' + esc(l.raw) + '<div class="ccx-alts"><span>' + lead + '</span>' + vs.map(function (v) {
        return '<button type="button" class="ccx-alt" data-ccx-alt="' + v.id + '" data-ccx-n="' + (v.p.shades ? l.q || 1 : 1) + '">+ ' + esc(altName(v)) + '</button>';
      }).join('') + '</div></li>';
    }
    // Clic sur un remplacement : ajouté comme une ligne lue (liste ou panier selon ce qui a déjà été choisi).
    function addAlt(b) {
      var vid = b.dataset.ccxAlt, n = +b.dataset.ccxN || 1, v = byVid[vid];
      if (!v || b.disabled) return;
      b.disabled = true; b.textContent = '✓ ' + altName(v) + (n > 1 ? ' × ' + n : '');
      built.qty[vid] = capQ(vid, (built.qty[vid] || 0) + n);
      if (mode === 'draft') { draft[vid] = built.qty[vid]; qty[vid] = built.qty[vid]; hits[vid] = 1; refreshVariant(vid); renderSum(); }
      else if (mode === 'cart') { hits[vid] = 1; setQty(vid, built.qty[vid]); }
      var cnt = 0, sum = 0;
      Object.keys(built.qty).forEach(function (id) { cnt += built.qty[id]; sum += unitPrice(byVid[id]) * built.qty[id]; });
      var sub = panel && panel.querySelector('.ccx-fin .ccx-sub');
      if (sub) sub.textContent = cnt + ' produits repérés · ' + money(sum) + ' HT';
      T('express', 'photo_remplacement', vid, { n: n });
    }

    /* ---------- fin : le client choisit, rien ne part dans le panier sans son clic ---------- */
    var hits = {}, mode = null, built = null;
    function finish() {
      built = build();
      var ids = Object.keys(built.qty), n = 0, sum = 0;
      ids.forEach(function (vid) { n += built.qty[vid]; sum += unitPrice(byVid[vid]) * built.qty[vid]; });
      var ox = [20, 10, 5].filter(function (v) { return built.split[v]; }).map(function (v) { return built.split[v] + ' × ' + v + ' vol'; }).join(', ');
      var unk = run.result.lines.filter(function (l) { return l.k === 'unknown' && !l.oos; });
      var oos = run.result.lines.filter(function (l) { return l.k === 'unknown' && l.oos; });
      swap('<div class="ccx-fin">' + CHECK.replace('ccx-ok', 'ccx-ok big') +
        '<p class="ccx-t">Super, votre commande est prête !</p>' +
        '<p class="ccx-sub">' + n + ' produits repérés · ' + money(sum) + ' HT</p>' +
        (ox ? '<p class="ccx-note">Oxydants répartis selon vos produits : ' + esc(ox) + '.</p>' : '') +
        '<div class="ccx-acts"><button type="button" class="cce-go" data-ccx-add>Passer ma commande</button>' +
        '<button type="button" class="ccp-cta" data-ccx-see>Voir le détail</button></div>' +
        (unk.length ? '<div class="ccx-unkbox"><p><b>Attention, ' + (unk.length > 1 ? unk.length + ' lignes non reconnues' : '1 ligne non reconnue') + '</b><br>' +
          'Nous n\'avons pas su ' + (unk.length > 1 ? 'les' : 'la') + ' rattacher à un produit : ' + (unk.some(function (l) { return l.alts; }) ? 'choisissez un remplacement proposé ou ajoutez-' : 'ajoutez-') + (unk.length > 1 ? 'les' : 'la') + ' à la main dans la liste.</p>' +
          '<ul>' + unk.map(altsHtml).join('') + '</ul></div>' : '') +
        (oos.length ? '<div class="ccx-unkbox ccx-oosbox"><p><b>' + (oos.length > 1 ? oos.length + ' produits momentanément en rupture' : 'Produit momentanément en rupture') + '</b></p>' +
          '<ul>' + oos.map(function (l) { return altsHtml({ raw: l.oos + (l.q ? ' × ' + l.q : ''), q: l.q, alts: l.alts, oos: l.oos }); }).join('') + '</ul></div>' : '') +
      '</div>');
      T('express', 'photo_prete', '', { lignes: ids.length, articles: n, remplacements: unk.filter(function (l) { return l.alts; }).length });
      run = null;
      // Les quantités sont posées dans la liste dès l'écran final, sans toucher au panier ni faire défiler la page.
      mode = null;
      apply(true, true);
    }
    // La liste est remplie dès l'écran final ; « Voir le détail » y fait défiler,
    // « Passer ma commande » envoie au panier et ouvre le panier coulissant. Jamais deux fois les mêmes produits.
    function apply(asDraft, quiet) {
      if (mode === 'draft' && !asDraft) {
        Object.keys(draft).forEach(function (vid) { pending[vid] = draft[vid]; });
        draft = {}; mode = 'cart';
        T('express', 'photo_ajout_panier', '', { apres: 'voir' });
        return openCart();
      }
      if (mode) return asDraft ? toFirst() : openCart();
      var ids = Object.keys(built.qty);
      mode = asDraft ? 'draft' : 'cart';
      hits = {};
      ids.forEach(function (vid) {
        hits[vid] = 1;
        // La photo fait foi pour ses lignes : on pose sa quantité, sans l'ajouter à ce qui est déjà au panier.
        var n = built.qty[vid] = capQ(vid, built.qty[vid]);
        if (asDraft) { draft[vid] = n; qty[vid] = n; refreshVariant(vid); } else setQty(vid, n);
      });
      // Onglet « Ma commande » ouvert pour vérifier la lecture ; « Tous les produits » reste à un clic.
      ids.forEach(function (vid) { var v = byVid[vid]; if (v && v.p.shades) state.open[v.p.id] = true; });
      state.only = true; state.q = ''; state.sec = 'all';
      renderChips(); renderList(); renderSum();
      if (quiet) return;
      T('express', asDraft ? 'photo_voir' : 'photo_ajout_panier', '', { lignes: ids.length });
      asDraft ? toFirst() : openCart();
    }
    function openCart() {
      clearTimeout(timer); flush();
      Promise.resolve(saving).then(function () { if (window.ccCart) window.ccCart.open(); else location.assign('/cart'); });
    }
    // Direction le premier produit rempli (hors « Promos et nouveautés »).
    function toFirst() {
      var first = [].filter.call(root.querySelectorAll('.ccp-hit'), function (x) { return !x.closest('.cce-hi'); })[0];
      if (!first) return;
      var sec = first.closest('.cce-p') || first;
      // L'en-tête se cache quand on descend : on vise le haut de l'écran, puis on corrige s'il est resté affiché.
      var tabs = root.querySelector('[data-cce-chips]'), tabH = tabs && getComputedStyle(tabs).position === 'sticky' ? tabs.offsetHeight : 0;
      window.scrollTo({ top: Math.max(0, sec.getBoundingClientRect().top + window.scrollY - 16 - tabH), behavior: REDUCE ? 'auto' : 'smooth' });
      setTimeout(function () {
        var hd = document.querySelector('.ccm-section') || document.querySelector('.section-header');
        var hb = hd ? hd.getBoundingClientRect().bottom : 0, top = sec.getBoundingClientRect().top;
        if (tabH) hb = Math.max(hb, tabs.getBoundingClientRect().bottom);
        if (hb > 0 && top < hb + 12) window.scrollBy({ top: top - hb - 12, behavior: REDUCE ? 'auto' : 'smooth' });
      }, REDUCE ? 50 : 900);
    }

    // Les lignes remplies depuis la photo restent repérées dans la liste.
    var baseRenderList = renderList;
    renderList = function () {
      baseRenderList();
      Object.keys(hits).forEach(function (vid) {
        root.querySelectorAll('[data-row="' + vid + '"]').forEach(function (r) { r.classList.add('ccp-hit'); });
        root.querySelectorAll('[data-step="' + vid + '"]').forEach(function (s) { var p = s.closest('.cce-ph'); if (p) p.parentNode.classList.add('ccp-hit'); });
      });
    };

    /* ---------- événements ---------- */
    box.addEventListener('click', function (e) {
      if (e.target.closest('[data-ccp-cam]')) cam.click();
      else if (e.target.closest('[data-ccp-pick]')) file.click();
    });
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-ccx-q],[data-ccx-back],[data-ccx-retry],[data-ccx-add],[data-ccx-see],[data-ccx-alt]');
      if (!b || !panel || !panel.contains(b)) return;
      if (b.hasAttribute('data-ccx-q')) {
        if (b.classList.contains('sel') && ans[b.dataset.ccxQ] === b.dataset.ccxV) return;
        panel.querySelectorAll('.ccx-opt').forEach(function (o) { o.classList.toggle('sel', o === b); });
        answer(b.dataset.ccxQ, b.dataset.ccxV);
      } else if (b.hasAttribute('data-ccx-back')) {
        ask(+b.dataset.ccxBack);
      } else if (b.hasAttribute('data-ccx-add')) apply(false);
      else if (b.hasAttribute('data-ccx-see')) apply(true);
      else if (b.hasAttribute('data-ccx-alt')) addAlt(b);
      else if (b.hasAttribute('data-ccx-retry')) { closePanel(); file.click(); }
    });
    file.addEventListener('change', function () { start(file.files); file.value = ''; });
    // Appareil photo : une seule prise à la fois. Les pages s'accumulent ici avant la lecture (5 au plus).
    var staged = [], tray = null;
    function renderTray() {
      if (!staged.length) { if (tray) tray.remove(); tray = null; box.hidden = false; return; }
      if (!tray) {
        tray = el('div', 'ccp-tray');
        box.parentNode.insertBefore(tray, box.nextSibling);
        tray.addEventListener('click', function (e) {
          var b = e.target.closest('[data-ccp-rm],[data-ccp-more],[data-ccp-go]');
          if (!b) return;
          if (b.hasAttribute('data-ccp-more')) return cam.click();
          if (b.hasAttribute('data-ccp-rm')) { var s = staged.splice(+b.getAttribute('data-ccp-rm'), 1)[0]; URL.revokeObjectURL(s.url); return renderTray(); }
          var files = staged.map(function (x) { URL.revokeObjectURL(x.url); return x.f; });
          staged = []; renderTray();
          start(files);
        });
      }
      box.hidden = true;
      var n = staged.length;
      tray.innerHTML = '<p class="ccp-tray-t">' + (n > 1 ? n + ' pages prêtes' : '1 page prête') + '</p>' +
        '<div class="ccp-tray-shots">' + staged.map(function (s, i) {
          return '<span class="ccp-tray-shot"><img src="' + s.url + '" alt="Page ' + (i + 1) + '"><button type="button" data-ccp-rm="' + i + '" aria-label="Retirer la page ' + (i + 1) + '">×</button></span>';
        }).join('') + '</div>' +
        '<div class="ccp-tray-acts">' +
        (n < MAX_FILES ? '<button type="button" class="ccp-cta ccp-more" data-ccp-more>+ Ajouter une nouvelle page</button>' : '') +
        '<button type="button" class="ccp-cta" data-ccp-go>' + (n > 1 ? 'Utiliser ces ' + n + ' photos' : 'Utiliser cette photo') + '</button></div>';
    }
    cam.addEventListener('change', function () {
      [].slice.call(cam.files || []).forEach(function (f) { if (staged.length < MAX_FILES) staged.push({ f: f, url: URL.createObjectURL(f) }); });
      cam.value = '';
      if (!run) renderTray();
    });
    ['dragenter', 'dragover'].forEach(function (ev) { box.addEventListener(ev, function (e) { e.preventDefault(); box.classList.add('over'); }); });
    ['dragleave', 'drop'].forEach(function (ev) { box.addEventListener(ev, function (e) { e.preventDefault(); box.classList.remove('over'); }); });
    box.addEventListener('drop', function (e) { start(e.dataTransfer.files); });
  })();
  renderChips(); renderList(); renderSum();
  // Nouvelle commande ouverte depuis le CRM : on part d'un panier vide.
  // Le pré-remplissage CRM ne vaut que pour CE panier : un autre panier repris dans l'onglet (lien de récupération…)
  // ne doit jamais partir avec les coordonnées de cette cliente (cc-cart compare le jeton du panier).
  (crmFresh ? api('/cart/clear.js', {}) : Promise.resolve()).catch(function () {}).then(loadCart).then(function () {
    try {
      var tok = cart && String(cart.token || '').split('?')[0];
      if (crmFresh && tok) sessionStorage.setItem('cc_crm_cart', tok);
      if (crmClient() && sessionStorage.getItem('cc_crm_cart') !== tok) { var bd = document.getElementById('cfm-autofill-badge'); if (bd) bd.remove(); }
    } catch (e) {}
  }).then(renderList);
})();
